import {
  DEAL_NOT_AVAILABLE_ERROR_MODAL,
  MODAL_CTA,
  SWITCH_TO_PICKUP,
} from '../../../constants/AnalyticsConstants';

export const getParameterByName = (name: string, url?: string) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const redirectToLanguageContext = (langCode: string) => {
  const paths = window.location.pathname.split('/');
  paths.shift();
  //matching the url language with 5 character length as per the current language code from sitecore.
  if (paths[0].match('[a-z]{2}-[A-Za-z]{2}')) {
    paths[0] = langCode;
  }
  window.location.href = window.location.origin + '/' + paths.join('/');
};

export const navigateToLocatorPage = (
  withoutPromo?: any,
  setAnalyticsProducts?: any,
  setAttemptTracker?: any,
) => {
  const offerParams = getParameterByName('offer');
  const productId = getParameterByName('mProductId');
  const categoryId = getParameterByName('mCategoryId');
  const menuSlider = '?mProductId=' + productId + '&' + 'mCategoryId=' + categoryId;
  const promotionPLUId = getParameterByName('promoId');
  const promoCodeData = getParameterByName('promoCode');
  let offerdata = '';
  let promotionID = '';
  let promoCodeId = '';
  const maintainCartUrl =  "?" + window.subwayScript.IsEdit + "=true";
  if (offerParams) {
    offerdata = '?offer=' + offerParams;
  }

  if (promotionPLUId && withoutPromo != 'withoutPromo') {
    promotionID = '?promoId=' + promotionPLUId;
  }

  if (promoCodeData && withoutPromo != 'withoutPromo') {
    promoCodeId = '&promoCode=' + promoCodeData;
  }

  if (window.orderViewModel.maintainCartAddressClick) {
    window.location.href = window.subwayScript.navigation.getLocatorUrl();
  } else if (window.location.href.toLowerCase().indexOf(window.subwayScript.IsEdit) > 1) {
    window.location.href = `${
      window.location.origin
    }${window.subwayScript.navigation.getLocatorUrl()}${maintainCartUrl}`;
  } else if (window.orderViewModel.currentOrder.cartQuantity) {
    window.orderViewModel.orderNowDashboardClick = true;
    window.orderViewModel.save();
    window.location.href = window.subwayScript.navigation.getLocatorUrl();
  } else if (productId && categoryId) {
    window.location.href = `${
      window.location.origin
    }${window.subwayScript.navigation.getLocatorUrl()}${menuSlider}`;
  } else {
    window.orderViewModel.flushCart();

    let redirectUrl = `${
      window.location.origin
    }${window.subwayScript.navigation.getLocatorUrl()}${offerdata}${promotionID}${promoCodeId}`;

    if (window.ShopPromotionFlag !== 'true') {
      redirectUrl = `${
        window.location.origin
      }${window.subwayScript.navigation.getLocatorUrl()}${offerdata}`;
    }

    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 500);

    setAnalyticsProducts({
      clickActionName: SWITCH_TO_PICKUP,
      virtualName: DEAL_NOT_AVAILABLE_ERROR_MODAL,
    });

    setAttemptTracker([{ name: MODAL_CTA, isClickable: true }]);
  }
};

export const getLocatorHeight = () => {
  const header =
    document.getElementsByClassName('deliverySection__mobileViewHeader').length > 0
      ? document.getElementsByClassName('deliverySection__mobileViewHeader')[0].clientHeight
      : 0;
  const tabSection =
    document.getElementsByClassName('deliveryLocator__sidePanel').length > 0
      ? document.getElementsByClassName('deliveryLocator__sidePanel')[0].clientHeight
      : 0;
  return `${header + tabSection}px`;
};

export const getLocatorMapHeaderHeight = () => {
  const header =
    document.getElementsByClassName('deliverySection__mobileViewHeader').length > 0
      ? document.getElementsByClassName('deliverySection__mobileViewHeader')[0].clientHeight
      : 0;
  const tabSection = 230;
  const footerSection = 110;
  return `${header + tabSection + footerSection}px`;
};

export const createCookie = (name: string, value: string, days: any) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
};

export const eraseCookie = (name: string) => {
  createCookie(name, '', -1);
};

export const calculateIsPromoByName = (promo: string) => {
  if (window.ShopPromotionFlag == 'true') {
    return getParameterByName(promo) ? true : false;
  } else {
    return false;
  }
};

export const disableMapADA = () => {
  return setInterval(function () {
    const gmStyleDivs = document.querySelectorAll('.gm-style div');
    const gmStyleButtons = document.querySelectorAll('.gm-style button');
    const gmStyleLinks = document.querySelectorAll('.gm-style a');

    for (const element of gmStyleDivs) {
      element.setAttribute('tabindex', '-1');
    }

    for (const element of gmStyleButtons) {
      element.setAttribute('tabindex', '-1');
    }

    for (const element of gmStyleLinks) {
      element.setAttribute('tabindex', '-1');
    }
  }, 100);
};

const getCookie = (cname: string) => {
  const name = cname.toString() + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  const val = ca.find(x => x.trim().startsWith(name));
  const res = val && val.split('=')[1];
  return res ? JSON.parse(res) : false;
};

export const setUserStoreCookie = (data: any, orderViewModel: any) => {
  let countryCookie = [];
  const getCookies = getCookie('userStoreData');
  const cookieData = {
    LocationId: {
      StoreNumber: data.LocationId.StoreNumber,
      SatelliteNumber: data.LocationId.SatelliteNumber,
      Ordertype: orderViewModel.orderType,
      Address: data.Address.Address1,
      Country: orderViewModel.scLanguageCode,
    },
  };
  if (!getCookies) {
    countryCookie.push(cookieData);
  } else {
    countryCookie = getCookies;
    const index =
      countryCookie.length > 0 &&
      countryCookie.findIndex(
        (resultData: any) => resultData.LocationId.Country === data.Address.CountryCode,
      );
    if (index == -1) {
      countryCookie.push(cookieData);
    } else {
      countryCookie[index] = cookieData;
    }
  }
  if (orderViewModel.hasLoggedIn) {
    window.subwayScript.setCookie('isStoreChange', true, 90);
  }
  window.subwayScript.setCookie('userStoreData', JSON.stringify(countryCookie), 90);
};
export const AddToCartOrderViewModal = (orderViewModel: any) => {
  if (orderViewModel.orderType === 'delivery') {
    orderViewModel.store.StoreId = (window as any).subwayScript.checkSatelliteNumber(orderViewModel.store.id);
    orderViewModel.store.address = orderViewModel.DeliveryAddress.StreetAddressLine1;
    orderViewModel.store.address1 = orderViewModel.DeliveryAddress.StreetAddressLine1;
    orderViewModel.store.address3 = null;
    orderViewModel.store.city = orderViewModel.DeliveryAddress.City;
    orderViewModel.store.countryCode = orderViewModel.DeliveryAddress.Country;
    orderViewModel.store.postalCode = orderViewModel.DeliveryAddress.Zip;
    orderViewModel.store.stateProvCode = orderViewModel.DeliveryAddress.State;
    orderViewModel.store.storeCountry = orderViewModel.DeliveryAddress.Country;
  } else {
    orderViewModel.store.StoreId = window.subwayScript.getStoreId(
      orderViewModel.storeData.LocationId.StoreNumber,
      orderViewModel.storeData.LocationId.SatelliteNumber,
    );
    orderViewModel.store.address = orderViewModel.storeData.Address.Address1;
    orderViewModel.store.address1 = orderViewModel.storeData.Address.Address1;
    orderViewModel.store.address3 = orderViewModel.storeData.Address.Address2;
    orderViewModel.store.city = orderViewModel.storeData.Address.City;
    orderViewModel.store.countryCode = orderViewModel.storeData.Address.CountryCode;
    orderViewModel.store.id = window.subwayScript.getStoreId(
      orderViewModel.storeData.LocationId.StoreNumber,
      orderViewModel.storeData.LocationId.SatelliteNumber,
    );
    orderViewModel.store.postalCode = orderViewModel.storeData.Address.PostalCode;
    orderViewModel.store.stateProvCode = orderViewModel.storeData.Address.stateProvCode;
  }
  orderViewModel.removeAndContinueMaintainCart = true;
  orderViewModel.save();
  const data = {
    LocationId: {
      StoreNumber: orderViewModel.store.StoreId,
      SatelliteNumber: orderViewModel.store.satelliteNumber,
      Ordertype: orderViewModel.orderType,
    },
    Address: {
      Address1: orderViewModel.store.address1,
      CountryCode: orderViewModel.store.countryCode,
    },
  };
  const lang = window.subwayScript.navigation.getLanguageCode().toLowerCase();
  if (
    window.location.href.toLowerCase() === window.location.origin + lang ||
    window.location.href.toLowerCase() === window.location.origin + lang + '/' ||
    window.location.href.toLowerCase().includes('utm_campaign')
  ) {
    setUserStoreCookie(data, orderViewModel);
  }
};

export const changeViewPort = () => {
  const elements = document.querySelectorAll<HTMLElement>(".body_container, .react-container, #root-react-pr");
  elements.forEach(function(element) {
      element.style.maxWidth = "1800px";
  });
}

export const getCartItemId = (response:any)=>{
  const arry: any[] = []
  const bundle: any[] = []
  response.forEach((item:any)=>{
    if(!item.isAvailable && !item.isBundleItem){
      arry.push(item.id)
    }
    if(!item.isAvailable && item.isBundleItem){
      bundle.push(item.id)
    }
  })
  return {cartItemArray: arry, bundleItemArray: bundle}
}